import { BaseClient, IActionResponse, IActionResult, IPagedResult } from "../";
import { ApiParams } from "../../../assets/utils/lib";
import { GridSubscriptionDto, SearchDto, SubscriptionDto } from "../../dto";

export class SubscriptionClient extends BaseClient {
    routes = ["admin", "Subscription"];

    async getAllSubscriptionsAsync(): Promise<SubscriptionDto[]> {
        const actions: string[] = ["GetAllSubscriptions"];

        const result: SubscriptionDto[] = await this.getAsync<SubscriptionDto[]>(actions);
        return result;
    }

    async getSubscriptionAsync(id: string | undefined): Promise<SubscriptionDto> {
        const actions: string[] = ["GetSubscription"];
        const params: ApiParams[] = [new ApiParams("Id", id, true)];

        const result: SubscriptionDto = await this.getAsync<SubscriptionDto>(actions, params);
        return result;
    }

    async getSubscriptionsAsync(communityId?: string | undefined): Promise<SubscriptionDto[]> {
        const actions: string[] = ["GetSubscriptions"];
        const params: ApiParams[] = [
            new ApiParams("communityId", communityId, true)
        ];

        const result: SubscriptionDto[] = await this.getAsync<SubscriptionDto[]>(actions, params);
        return result;
    }

    async searchSubscriptionsAsync(payload: SearchDto | undefined): Promise<IPagedResult<GridSubscriptionDto>> {
        const actions: string[] = ["SearchSubscriptions"];
        const result: IPagedResult<GridSubscriptionDto> = await this.postAsync<SearchDto, GridSubscriptionDto, IPagedResult<GridSubscriptionDto>>(actions, payload);
        return result;
    }

    async saveSubscriptionAsync(payload: SubscriptionDto | undefined): Promise<IActionResult<SubscriptionDto>> {
        const actions: string[] = ["SaveSubscription"];
        return await this.postAsync<SubscriptionDto>(actions, payload);
    }

    async deActivateSubscriptionAsync(id: string | undefined): Promise<IActionResponse> {
        const actions: string[] = ["DeActivateSubscription"];
        const params: ApiParams[] = [new ApiParams("Id", id, true)];
        return await this.getAsync(actions, params);
    }
}
